import React, { useState, useEffect, Fragment } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import Moment from "moment";
import { ProductDetailsStyled } from "./styled";
import {
  CustomBreadcrumb,
  PrimaryButton,
  ToggleButton,
  DeleteProductItem,
  CustomModal,
  DELETE_ITEM_TYPES,
  CUSTOM_MODAL_TYPES
} from "../../../components";
import {
  MARKETPLACE_CONSTANTS,
  PRODUCT_HEADERS,
  MARKETPLACE_CURRENCY_LIST,
} from "../../../config/constants";
import { Typography } from "@mui/material";
import { colors } from "../../../config/colors";
import {
  SideBarAddLogo,
  DeleteLogo,
  ProductSwapLogo,
  PlainEditLogo,
  PlainDeleteLogo,
  UpArrowLogo,
  DownArrowLogo,
} from "../../../assets/icons";
import { TEXT_ALIGN_LEFT } from "../../../config/styles";
import { Button, Form, Row } from "react-bootstrap";
import Specifications from "./Specifications";
import Variants from "./Variants";
import { OverrideList } from "./components/Overrides";
import { DisplayPeriod } from "./components";
import { API_URL } from "../../../utils/Constants";
import { ApiService } from "../../../utils/ApiService";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../config/routes";
import { getMerchantId } from "utils/Helper";

const ProductDetails = () => {
  const [allCategory, setAllCategory] = useState([]);
  const [formList, setFormList] = useState([]);
  const [specificationList, setSpecificationList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [productId, setProductId] = useState("");
  const [category, setCategory] = useState(null);
  const [currency, setCurrency] = useState("AED");
  const [formName, setFormName] = useState("");
  const [hasError, setHasError] = useState({});
  const [recommendedToggle, setRecommendedToggle] = useState(true);
  const [enabledToggle, setEnabledToggle] = useState(true);
  const [showSpecification, setShowSpecification] = useState(false);
  const [showVariant, setShowVariant] = useState(false);
  const [loader, setLoader] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteMode, setDeleteMode] = useState("");
  const [deleteItem, setDeleteItem] = useState("");
  const [editSpecIndex, setEditSpecIndex] = useState(null);
  const [editVariantIndex, setEditVariantIndex] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [failureMsg, setFailureMsg] = useState("");
  const [selectedDateTo,setSelectedDateTo] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [gradesDivisionList, setGradesDivisionList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [overrideList, setOverrideList] = useState([]);
  const [showOverrideForm, setShowOverrideForm] = useState(false);
  const [editOverrideIndex, setEditOverrideIndex] = useState(null);

  // Stock & Tax Management states
  const [stockControlEnabled, setStockControlEnabled] = useState(false);
  const [availableStock, setAvailableStock] = useState("");
  const [purchaseLimitEnabled, setPurchaseLimitEnabled] = useState(false);
  const [maxQuantityPerStudent, setMaxQuantityPerStudent] = useState("");
  const [stockTaxError, setStockTaxError] = useState({});

  const navigate = useNavigate();
  const onHideDeleteImage = () => setShowDelete(false);
  let productSelected = localStorage.getItem("productSelected");
  let productSelectedName = localStorage.getItem("productSelectedName");
  const merchantId = getMerchantId();
  const onSpecDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(specificationList);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setSpecificationList(items);
  };

  const onVariantDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(variantList);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setVariantList(items);
  };

  const resetForm = () => {
    setProductId("");
    setCategory(null);
    setCurrency("AED");
    setFormName("");
    setHasError({});
    setRecommendedToggle(true);
    setEnabledToggle(true);
    setShowSpecification(false);
    setShowVariant(false);
    setLoader(false);
    setImageList([]);
    setSpecificationList([]);
    setVariantList([]);
    setSuccessMsg("");
    setFailureMsg("");
    setSelectedDateTo("");
    setSelectedDateFrom("");
    // Reset Stock & Tax Management
    setStockControlEnabled(false);
    setAvailableStock("");
    setPurchaseLimitEnabled(false);
    setMaxQuantityPerStudent("");
    setStockTaxError({});
  };

  useEffect(() => {
    getAllForms();
    onFetchGradeDivision();
    getAllCategory();
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    if (productSelected) {
      !loader && getProductDetails();
    }
    // eslint-disable-next-line
  }, [productSelected]);

  const manageRecommendedToggle = () =>
    setRecommendedToggle(!recommendedToggle);
  const manageEnabledToggle = () => setEnabledToggle(!enabledToggle);
  const manageSpecificationToggle = () => {
    setEditSpecIndex(null);
    setShowSpecification(!showSpecification);
  };
  const manageVariantToggle = () => {
    setEditVariantIndex(null);
    setShowVariant(!showVariant);
  };

  const getAllCategory = async () => {
    try {
      const url = API_URL.PRODUCT_CATEGORIES + "?merchantId=" + merchantId;
      const response = await ApiService.getRequest(url, PRODUCT_HEADERS);
      if (response?.status?.code === "Y") {
        setAllCategory(response?.body || []);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getAllForms = async () => {
    try {
      let url = API_URL.GET_PRODUCT_FORMS + "?merchantId=" + merchantId;
      const response = await ApiService.getRequest(url, PRODUCT_HEADERS);
      if (response?.status?.code === "Y") {
        setFormList(response?.body || []);
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
    }
  };

  const getProductDetails = async () => {
    setLoader(true);
    try {
      let url = API_URL.PRODUCT_DETAILS + productSelected;
      let response = await ApiService.getRequest(url, PRODUCT_HEADERS);
      setProductId(response?.body?.productId);
      setCategory(response?.body?.category);
      setCurrency(response?.body?.currency);
      setFormName(response?.body?.formName || "");
      setRecommendedToggle(response?.body?.recommended);
      setEnabledToggle(response?.body?.enabled);
      setImageList(response?.body?.images || []);
      setSpecificationList(response?.body?.specifications || []);
      setVariantList(response?.body?.variants || []);
      setOverrideList(response?.body?.overrides || []);
      let fromDateFormatted = Moment(response?.body?.activeFrom).format("YYYY-MM-DD") || ""
      setSelectedDateFrom(fromDateFormatted);
      let toDateFormatted = Moment(response?.body?.activeTill).format("YYYY-MM-DD") || ""
      setSelectedDateTo(toDateFormatted);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
    setLoader(false);
  };

  const onFetchGradeDivision = async () => {
      try {
        const url = API_URL.GET_GRADE_DIVISON + "/" + merchantId;
        const resp = await ApiService.getRequest(url);
        if (resp.status && resp.status.code === "Y") {
          const grades = resp.body.map((item) => item.grade);
          setGradesDivisionList(resp.body);
          setGradeList(grades);
        }
      } catch (err) {
        console.error("Error fetching grade and division data:", err);
      }
    };

  const manageDeleteSpecification = () => {
    setSpecificationList((prevSpecifications) =>
      prevSpecifications.filter((_, idx) => idx !== editSpecIndex)
    );
  };

  const manageDeleteVariant = () => {
    setVariantList((prevVariant) =>
      prevVariant.filter((_, idx) => idx !== editVariantIndex)
    );
  };

  const manageDeleteOverride = () => {
    setOverrideList((prevOverrides) =>
      prevOverrides.filter((_, idx) => idx !== editOverrideIndex)
    );
  };

  const handleSelectChange = (fieldName, e) => {
    let value = e?.target?.value;
    switch (fieldName) {
      case "category":
        setCategory(value);
        setHasError({ ...hasError, category: "" });
        break;
      case "currency":
        setCurrency(value);
        setHasError({ ...hasError, currency: "" });
        break;
      case "formName":
        setFormName(value);
        setHasError({ ...hasError, formName: "" });
        break;
      default:
        break;
    }
  };

  const handleFromDateChange = (date) => {
    let fromDateString = Moment(date).format("YYYY-MM-DD");
    setSelectedDateFrom(fromDateString);
  };

  const handleToDateChange = (date) => {
    let fromDateString = Moment(date).format("YYYY-MM-DD");
    setSelectedDateTo(fromDateString);
  };

  const uploadImage = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      setHasError({
        ...hasError,
        uploadImage: "Please select a valid image file (PNG or JPEG only)",
      });
      event.target.value = ""; // Clear the input
      return;
    }

    // File size validation (2MB = 2 * 1024 * 1024 bytes)
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    if (file.size > maxSize) {
      setHasError({
        ...hasError,
        uploadImage: "File size must be less than 2MB",
      });
      event.target.value = ""; // Clear the input
      return;
    }

    // Clear any previous errors
    setHasError({
      ...hasError,
      uploadImage: "",
    });

    try {
      setLoader(true);
      const base64String = await convertFileToBase64(file);
      const requestData = {
        file: base64String, // base64 string without data:image/...;base64, prefix
      };
      const response = await ApiService.postRequest(
        API_URL.UPLOAD_PRODUCT_IMAGE, // You may need to add this to your API_URL constants
        requestData,
        PRODUCT_HEADERS
      );

      if (response?.status?.code === "Y") {
        setHasError({
          ...hasError,
          uploadImage: "",
        });
        setImageList((prevImages) => [...prevImages, response?.body]);
        event.target.value = "";
      } else {
        setHasError({
          ...hasError,
          uploadImage: response?.status?.message || "Failed to upload image",
        });
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setHasError({
        ...hasError,
        uploadImage: "Failed to upload image. Please try again.",
      });
    } finally {
      setLoader(false);
    }
  };

  // Helper function to convert file to base64
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        // Remove the data:image/...;base64, prefix to get just the base64 string
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const deleteImage = async () => {
    try {
      const response = await ApiService.deleteRequest(
        `${API_URL.GET_PRODUCT_IMAGE}${deleteItem}`,
        "",
        PRODUCT_HEADERS
      );
      if (response?.status?.code === "Y") {
        setImageList((prevImages) =>
          prevImages.filter((image) => image.id !== deleteItem)
        );
        setDeleteItem(null);
      } else {
        console.error("Failed to delete image:", response?.status?.message);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    } finally {
      setShowDelete(false);
    }
  };
  const handleSave = async () => {
    // Validate Stock & Tax Management fields. that i will do while implementing the backend
    let stockErrors = {};
    if (stockControlEnabled && !availableStock) {
      stockErrors.availableStock = "Available stock is required";
    }
    if (purchaseLimitEnabled && !maxQuantityPerStudent) {
      stockErrors.maxQuantityPerStudent = "Maximum quantity per student is required";
    }

    if (Object.keys(stockErrors).length > 0) {
      setStockTaxError(stockErrors);
      return;
    }

    if (!category || !merchantId || isEmpty(variantList)) {
      setHasError({
        category: !category ? "Category is required" : "",
        merchantId: !merchantId ? "Merchant Name is required" : "",
      });
      if (isEmpty(variantList)) {
        setShowVariant(true);
      }
      return;
    } else {
      try {
        let requestData = {
          productId: productId,
          category: category,
          merchantId: merchantId,
          currency: currency,
          enabled: enabledToggle,
          recommended: recommendedToggle,
          images: imageList.map((image) => ({ id: image.id })),
          specifications: specificationList,
          variants: variantList,
          overrides: overrideList,
          formName: formName,
          activeFrom: selectedDateFrom,
          activeTill: selectedDateTo,
        };
        const response = await ApiService.postRequest(
          API_URL.SAVE_PRODUCT,
          requestData,
          PRODUCT_HEADERS
        );
        if (response?.status?.code === "Y") {
          setHasError({});
          setSuccessMsg(
            response?.status?.message || "Product saved successfully"
          );
          localStorage.setItem("productSelected", "");
          localStorage.setItem("productSelectedName", "");
        } else if (response?.status?.code === "N") {
          setFailureMsg(response?.status?.message || "Failed to save product");
        }
      } catch (error) {
        console.error("Error saving product details:", error);
        setHasError({
          saveProduct: "Failed to save product details. Please try again.",
        });
      }
    }
  };

  const handleDelete = () => {
    if (deleteMode === DELETE_ITEM_TYPES.IMAGE) {
      deleteImage();
    } else if (deleteMode === DELETE_ITEM_TYPES.SPECIFICATION) {
      manageDeleteSpecification();
      setEditSpecIndex(null);
    } else if (deleteMode === DELETE_ITEM_TYPES.VARIANT) {
      manageDeleteVariant();
      setEditVariantIndex(null);
    } else if (deleteMode === DELETE_ITEM_TYPES.OVERRIDE) {
      manageDeleteOverride();
      setEditOverrideIndex(null);
    }
    setDeleteMode("");
    setDeleteItem("");
    setShowDelete(false);
  };

  const handleSaveVariant = (variantDetails) => {
    let updatedVariants = [...variantList];
    if (
      !(
        updatedVariants.length < 2 ||
        !variantDetails.defaultVariant ||
        !updatedVariants.find((v) => v.defaultVariant)
      )
    ) {
      updatedVariants = updatedVariants.map((v) => ({
        ...v,
        defaultVariant: false,
      }));
    }
    if (editVariantIndex !== null) {
      updatedVariants[editVariantIndex] = variantDetails;
    } else {
      updatedVariants.push(variantDetails);
    }
    setVariantList(updatedVariants);
    setShowVariant(false);
    setEditVariantIndex(null);
  };

  const handleOnDeleteOverride = (idx) => {
      setDeleteMode(DELETE_ITEM_TYPES.OVERRIDE || "OVERRIDE");
      setDeleteItem(overrideList[idx]?.grade);
      setShowDelete(true);
      setEditOverrideIndex(idx);
  }

  return (
    <ProductDetailsStyled>
      <CustomBreadcrumb
        isFromMarketplace={true}
        header={MARKETPLACE_CONSTANTS.PRODUCTS}
        currentPage={productSelectedName}
      >
        <Form className="modal-form" autoComplete="nope">
          <div className="configuration-page">
            <div className="configuration-general">
              <Typography variant="h5" className="mb-4">
                General information
              </Typography>
              {/* Category */}
              <Form.Floating as={Row} className="mb-3 mx-1" controlId="">
                <Form.Control
                  as="select"
                  onChange={(e) => {
                    handleSelectChange("category", e);
                  }}
                  value={category}
                  required
                  className="form-select"
                >
                  <option selected disabled></option>
                  {allCategory.map((category) => (
                    <option key={category.id} value={category.labelEn}>
                      {category.labelEn}
                    </option>
                  ))}
                </Form.Control>
                <label htmlFor="category">
                  <span>{MARKETPLACE_CONSTANTS.CATEGORY}</span>
                  <span style={{ color: colors.warning }}> *</span>
                </label>
              </Form.Floating>
              <div className="mb-3 mx-1" style={{ color: colors.warning }}>
                {hasError["category"]}
              </div>

              {/* Merchant ID */}
              {/* <Form.Floating as={Row} className="mb-3 mx-1" controlId="">
                <Form.Control
                  as="select"
                  onChange={(e) => {
                    handleSelectChange("merchantId", e);
                  }}
                  value={merchantId}
                  required
                  className="form-select"
                >
                  <option selected disabled></option>
                  {merchantList.map(
                    (merchant) =>
                      merchant.name && (
                        <option
                          key={merchant.merchantId}
                          value={merchant.merchantId}
                        >
                          {merchant.name}
                        </option>
                      )
                  )}
                </Form.Control>
                <label htmlFor="merchantId">
                  <span>{MARKETPLACE_CONSTANTS.MERCHANT_ID}</span>
                  <span style={{ color: colors.warning }}> *</span>
                </label>
              </Form.Floating>
              <div className="mb-3 mx-1" style={{ color: colors.warning }}>
                {hasError["merchantId"]}
              </div> */}

              {/* Currency */}
              <Form.Floating as={Row} className="mb-3 mx-1" controlId="">
                <Form.Control
                  as="select"
                  onChange={(e) => {
                    handleSelectChange("currency", e);
                  }}
                  value={currency}
                  required
                  className="form-select"
                >
                  {MARKETPLACE_CURRENCY_LIST.map((currencyItem) => (
                    <option key={currencyItem} value={currencyItem}>
                      {currencyItem}
                    </option>
                  ))}
                </Form.Control>
                <label htmlFor="currency">
                  {MARKETPLACE_CONSTANTS.CURRENCY}
                </label>
              </Form.Floating>
              <div className="mb-3 mx-1" style={{ color: colors.warning }}>
                {hasError["currency"]}
              </div>
              {/* Form name */}
              <Form.Floating as={Row} className="mb-3 mx-1" controlId="">
                <Form.Control
                  as="select"
                  onChange={(e) => {
                    handleSelectChange("formName", e);
                  }}
                  value={formName}
                  className="form-select"
                >
                  <option selected disabled></option>
                  {formList.length > 0 &&
                    formList.map((form) => (
                      <option key={form.id} value={form.name}>
                        {form.name}
                      </option>
                    ))}
                </Form.Control>
                <label htmlFor="formName">
                  {MARKETPLACE_CONSTANTS.VARIANT_FORM_LABEL}
                </label>
              </Form.Floating>
              <div className="mb-3 mx-1" style={{ color: colors.warning }}>
                {hasError["formName"]}
              </div>
              {/* Recommended */}
              <div className="d-flex w-100 justify-content-between align-items-center mb-4 mx-1">
                <div>
                  <Typography variant="h5" className="mb-1">
                    {MARKETPLACE_CONSTANTS.RECOMMENDED}
                  </Typography>
                  <Typography variant="h4">
                    {MARKETPLACE_CONSTANTS.RECOMMENDED_DETAILS}
                  </Typography>
                </div>
                <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
                  <div>
                    <ToggleButton
                      isChecked={recommendedToggle}
                      onClick={manageRecommendedToggle}
                    />
                  </div>
                </div>
              </div>

              {/* Enabled */}
              <div className="d-flex w-100 justify-content-between align-items-center mb-4 mx-1">
                <div>
                  <Typography variant="h5" className="mb-1">
                    {MARKETPLACE_CONSTANTS.ENABLED}
                  </Typography>
                  <Typography variant="h4">
                    {MARKETPLACE_CONSTANTS.ENABLED_DETAILS}
                  </Typography>
                </div>
                <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
                  <div>
                    <ToggleButton
                      isChecked={enabledToggle}
                      onClick={manageEnabledToggle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* Display Period */}
          <DisplayPeriod
            dateFrom={selectedDateFrom}
            dateTo={selectedDateTo}
            onDateFromChange={handleFromDateChange}
            onDateToChange={handleToDateChange}
          /> 

          {/* Images */}
          <div className="configuration-page">
            <div className="configuration-general">
              <Typography variant="h5" className="mb-4">
                {MARKETPLACE_CONSTANTS.IMAGES}
              </Typography>
            </div>
            {imageList.map((image) => {
              return (
                <div key={image.id} className="image-box">
                  <Typography variant="subtitle2">{image.id}</Typography>
                  <Button
                    style={{ background: "none", border: "none" }}
                    onClick={() => {
                      setDeleteMode(DELETE_ITEM_TYPES.IMAGE);
                      setDeleteItem(image.id);
                      setShowDelete(true);
                    }}
                  >
                    <DeleteLogo />
                  </Button>
                </div>
              );
            })}
            {imageList.length < 5 && (
              <Fragment>
                <Form.Group className="upload-image-box">
                  <SideBarAddLogo bgColor={colors.primary} />
                  <div className="w-100">
                    <Typography
                      variant="body1"
                      className="mb-2"
                      sx={{ color: colors.primary }}
                    >
                      {MARKETPLACE_CONSTANTS.UPLOAD_IMAGE}
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        color: colors.grayLight,
                        textAlign: TEXT_ALIGN_LEFT,
                      }}
                    >
                      {MARKETPLACE_CONSTANTS.UPLOAD_IMAGE_DETAILS}
                    </Typography>
                  </div>
                  <Form.Control
                    id="custom-file"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={uploadImage}
                  />
                </Form.Group>
                <div className="mb-3 mx-1" style={{ color: colors.warning }}>
                  {hasError["uploadImage"]}
                </div>
              </Fragment>
            )}
          </div>
          {/* Specifications */}
          <div className="configuration-page">
            <div className="d-flex justify-content-between align-items-center  configuration-general">
              <Typography variant="h5" className="d-flex align-items-center">
                {MARKETPLACE_CONSTANTS.SPECIFICATION}
              </Typography>
              <Button
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                className="d-flex align-items-center gap-2"
                onClick={manageSpecificationToggle}
              >
                <SideBarAddLogo bgColor={colors.primary} />
                <Typography
                  variant="body1"
                  sx={{ color: colors.primary }}
                  component="span"
                >
                  {MARKETPLACE_CONSTANTS.ADD_SPECIFICATION}
                </Typography>
              </Button>
            </div>
            <DragDropContext onDragEnd={onSpecDragEnd}>
              <Droppable droppableId="specifications">
                {(provided) => (
                  <div
                    className="d-flex flex-column gap-1 w-100"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {specificationList.map((specification, idx) => (
                      <Draggable
                        key={idx}
                        draggableId={String(idx)}
                        index={idx}
                      >
                        {(provided) => (
                          <Fragment>
                            <div
                              className="specification-wrapper"
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div className="d-flex gap-3 w-75">
                                <Button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    display: "flex",
                                    cursor: "grab",
                                  }}
                                >
                                  <ProductSwapLogo />
                                </Button>
                                <div>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ textAlign: TEXT_ALIGN_LEFT }}
                                  >
                                    {specification.title}
                                  </Typography>
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      textAlign: TEXT_ALIGN_LEFT,
                                      color: colors.grayLight,
                                    }}
                                  >
                                    {specification.value}
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ textAlign: TEXT_ALIGN_LEFT }}
                                    className="mt-2"
                                  >
                                    {specification.titleAr}
                                  </Typography>
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      textAlign: TEXT_ALIGN_LEFT,
                                      color: colors.grayLight,
                                    }}
                                  >
                                    {specification.valueAr}
                                  </Typography>
                                </div>
                              </div>
                              <div className="d-flex w-25 align-items-start justify-content-end gap-3">
                                <Button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                  }}
                                  onClick={() => {
                                    setShowSpecification(false);
                                    setEditSpecIndex(idx);
                                  }}
                                >
                                  <PlainEditLogo />
                                </Button>
                                <Button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                  }}
                                  onClick={() => {
                                    setDeleteMode(
                                      DELETE_ITEM_TYPES.SPECIFICATION
                                    );
                                    setDeleteItem(specification.title);
                                    setShowDelete(true);
                                    setEditSpecIndex(idx);
                                    setShowSpecification(false);
                                  }}
                                >
                                  <PlainDeleteLogo />
                                </Button>
                              </div>
                            </div>
                            {editSpecIndex === idx && (
                              <Specifications
                                initialValues={specification}
                                onDelete={() => {
                                  setDeleteMode(
                                    DELETE_ITEM_TYPES.SPECIFICATION
                                  );
                                  setDeleteItem(specification.title);
                                  setShowDelete(true);
                                  setEditSpecIndex(idx);
                                  setShowSpecification(false);
                                }}
                                onSave={(specificationDetails) => {
                                  const updatedList = [...specificationList];
                                  updatedList[idx] = specificationDetails;
                                  setSpecificationList(updatedList);
                                  setEditSpecIndex(null);
                                }}
                              />
                            )}
                          </Fragment>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {showSpecification ? (
              <Specifications
                onSave={(specificationDetails) => {
                  setSpecificationList([
                    ...specificationList,
                    specificationDetails,
                  ]);
                  setEditSpecIndex(null);
                  setShowSpecification(false);
                }}
              />
            ) : null}
          </div>
          {/* Variants */}
          <div className="configuration-page">
            <div className="d-flex justify-content-between align-items-center  configuration-general">
              <Typography variant="h5" className="d-flex align-items-center">
                {MARKETPLACE_CONSTANTS.VARIANT}
              </Typography>
              <Button
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                className="d-flex align-items-center gap-2"
                onClick={manageVariantToggle}
              >
                <SideBarAddLogo bgColor={colors.primary} />
                <Typography
                  variant="body1"
                  sx={{ color: colors.primary }}
                  component="span"
                >
                  {MARKETPLACE_CONSTANTS.ADD_VARIANT}
                </Typography>
              </Button>
            </div>
            <DragDropContext onDragEnd={onVariantDragEnd}>
              <Droppable droppableId="variants">
                {(provided) => (
                  <div
                    className="d-flex flex-column gap-1 w-100"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {variantList.map((variant, idx) => (
                      <Draggable
                        key={idx}
                        draggableId={String(idx)}
                        index={idx}
                      >
                        {(provided) => (
                          <Fragment>
                            <div
                              className="specification-wrapper"
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div className="d-flex gap-3 w-75 align-items-center">
                                <Button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    display: "flex",
                                    cursor: "grab",
                                  }}
                                >
                                  <ProductSwapLogo />
                                </Button>

                                <Typography
                                  variant="body1"
                                  sx={{ textAlign: TEXT_ALIGN_LEFT }}
                                >
                                  {variant.title}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    textAlign: TEXT_ALIGN_LEFT,
                                    color: colors.grayLight,
                                  }}
                                >
                                  {variant.enabled ? "Enabled" : ""}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    textAlign: TEXT_ALIGN_LEFT,
                                    color: colors.grayLight,
                                  }}
                                >
                                  {variant.defaultVariant ? "Default" : ""}
                                </Typography>
                              </div>
                              <div className="d-flex w-25 align-items-start justify-content-end">
                                <Button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                  }}
                                  onClick={() => {
                                    setDeleteItem(variant.title);
                                    setShowVariant(false);
                                    setEditVariantIndex(idx);
                                  }}
                                >
                                  {idx === editVariantIndex ? (
                                    <UpArrowLogo />
                                  ) : (
                                    <DownArrowLogo />
                                  )}
                                </Button>
                              </div>
                            </div>
                            {editVariantIndex === idx && (
                              <Variants
                                initialValues={variant}
                                onDelete={() => {
                                  setDeleteMode(DELETE_ITEM_TYPES.VARIANT);
                                  setDeleteItem(variant.title);
                                  setShowDelete(true);
                                  setEditVariantIndex(idx);
                                  setShowVariant(false);
                                }}
                                onSave={(variantDetails) => {
                                  handleSaveVariant(variantDetails);
                                }}
                                variantList={variantList}
                                currency={currency}
                                formList={formList}
                              />
                            )}
                          </Fragment>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {showVariant ? (
              <Variants
                onSave={(variantDetails) => {
                  handleSaveVariant(variantDetails);
                }}
                variantList={variantList}
                currency={currency}
                formList={formList}
              />
            ) : null}
          </div>

           {/* Product Override */}
          <OverrideList
            overrideList={overrideList}
            currency={currency}
            gradesDivisionList={gradesDivisionList}
            gradeList={gradeList}
            merchantId={merchantId}
            editOverrideIndex={editOverrideIndex}
            showOverrideForm={showOverrideForm}
            onOverrideListChange={setOverrideList}
            onEditOverrideIndexChange={setEditOverrideIndex}
            onShowOverrideFormChange={setShowOverrideForm}
            onDeleteOverride={handleOnDeleteOverride}
          />

          <div className="configuration-page p-0 border-0">
            <PrimaryButton
              label={MARKETPLACE_CONSTANTS.SAVE_BUTTON}
              onClick={handleSave}
            />
          </div>
        </Form>
      </CustomBreadcrumb>
      <DeleteProductItem
        show={showDelete}
        onHide={onHideDeleteImage}
        description={deleteItem}
        type={deleteMode}
        onDone={handleDelete}
      />
      <CustomModal
        show={successMsg || failureMsg}
        modalType={
          failureMsg ? CUSTOM_MODAL_TYPES.FAILURE : CUSTOM_MODAL_TYPES.SUCCESS
        }
        onHide={() => {
          resetForm();
          navigate(ROUTES.MARKETPLACE);
        }}
        title={failureMsg ? failureMsg : successMsg}
        message=""
      />
    </ProductDetailsStyled>
  );
};

export default ProductDetails;
